import React, { useMemo, useState, useCallback } from "react";
import lodashGet from "lodash/get";
import styles from "./workcard.module.less";
import IconFont from "@/components/icon";
import { changeEgovUrl } from "@/utils/tools";
import defaultIcon from "../../../../../assets/img/file-icon/ic1_weekly@2x.png";
import DownloadService from "@/server/DownloadService";
import { getJoySpacePageLink } from "@jd/focus-desktop-comps/lib/es/utils";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { FocusSDK } from "@/utils";
import dayjs from "dayjs";
import { preivewFileWPS } from "@/utils/chat/message";

function WorkCardDetail(props: any) {
  const { message, dataInfo } = props;
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const {
    fileService: { imAppKey },
    joyspaceHost
  } = appRuntimeEnv;
  const pages = useMemo(() => {
    return lodashGet(dataInfo, "pages", []);
  }, [dataInfo]);
  const schedules = useMemo(() => {
    return lodashGet(dataInfo, "schedules", []);
  }, [dataInfo]);

  const titleDetail = useMemo(() => {
    const pageStr = pages?.length > 0 ? `${pages?.length}篇协同文档` : "";
    const scheduleStr = schedules?.length > 0 ? `，${schedules?.length}个日程` : "";
    return `已总结${pageStr}${scheduleStr}`;
  }, [pages.length, schedules.length]);

  // 打开文档
  const handleFileItemClick = useCallback(
    (item: any) => {
      const { downloadUrl, pageType, pageId, title } = item;
      // console.log(item, "handleFileItemClick>ls", pageType, title);
      //   if (Number(pageType) === 2) {
      //     // 另存为
      //     if (canJoyspacePreview(title)) {
      //       return preivewFileWPS({ appKey: imAppKey, downloadUrl: downloadUrl }, { joyspaceHost });
      //     }
      //     return downLoadFile(title, downloadUrl);
      //   } else {
      // 打开文档
      window.open(
        getJoySpacePageLink(joyspaceHost, {
          pageType: pageType,
          id: pageId
        })
      );
      //   }
    },
    [imAppKey, joyspaceHost]
  );

  // 打开日程
  const handleScheduleClick = useCallback((item) => {
    FocusSDK.sendToMain("ai:global:openSchedule", {
      ...item
    });
  }, []);

  return (
    <div
      className={`${styles["word-summery-detail-wrap"]} ${showDetail ? styles["showMore"] : ""}`}
    >
      <div className={styles["header-wrap"]} onClick={() => setShowDetail(!showDetail)}>
        <IconFont className={styles["icon"]} type="iconpc_ic_chenggong_doc" />
        <span className={styles["text"]}>{titleDetail}</span>
        <IconFont className={styles["arrow"]} type={showDetail ? "iconicon_up" : "iconicon_down"} />
      </div>
      <div className={styles["detail-wrap"]}>
        {pages?.length > 0 ? (
          <div className={styles["card-wrap"]}>
            <span className={styles["title"]}>【协同文档】</span>
            <div className={styles["list-wrap"]}>
              {pages?.map((p: any, idx: number) => {
                return (
                  <div
                    className={styles["item"]}
                    key={`${message.id}_page_${idx}`}
                    onClick={() => handleFileItemClick(p)}
                  >
                    <span>{`${idx + 1}. `}</span>
                    <img
                      className={styles["icon"]}
                      src={p.iconUrl ? changeEgovUrl(p.iconUrl) : defaultIcon}
                    />
                    <span className={styles["text"]}>{p.title}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {schedules?.length > 0 ? (
          <div className={`${styles["card-wrap"]} ${styles["schedule"]}`}>
            <span className={styles["title"]}>【日程】</span>
            <div className={styles["list-wrap"]}>
              {schedules?.map((p: any, idx: number) => {
                return (
                  <div
                    className={styles["item"]}
                    key={`${message.id}_schedule_${idx}`}
                    onClick={() => handleScheduleClick(p)}
                  >
                    <span>{`${idx + 1}. `}</span>
                    <IconFont className={styles["icon"]} type="iconic-pc-schedule" />
                    <span className={styles["text"]}>{p.topic}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default WorkCardDetail;
